import { react2angular } from 'react2angular';
import { DataScope } from './DataScope';

angular
  .module('webtip.module')
  .component('analysisDataScope', react2angular(DataScope, ['operator', 'scopeValue', 'onDataScopeChange']));
